export enum ComparisonType {
    None,
    Days,
    Routes,
    Random
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/comparisonType.ts